import React, { useState, useEffect } from "react";
import { object, string } from "prop-types";
import { get } from "lodash";

import More from "../../atoms/More";
import PollStory from "../../molecules/pollStory";
import Polltype from "../../story-templates/StoryCard/PolltypeElement";
import { DfpComponent } from "../../ads/dfp-component";
import DfpContainer from "../../ads/dfp-container";

import { staticTexts } from "../../utils/Translate";
import { getPollingStories } from "../../helper/api";
import { getSlotId } from "../../utils/utils";

import "./pollResults.m.css";

export function PollResults({ collection, collectionSlug, lang = "bn" }) {
  if (!(collection && collection.items && collection.items.length)) return null;

  const stories = collection.items.filter(({ type }) => type === "story");
  const [inActivePolls, setInActivePolls] = useState([]);
  const [showButtonSpinner, setButtonSpinner] = useState(false);
  const [offset, setOffset] = useState(collection.items.length);

  const layoutName = get(collection, ["associated-metadata", "layout"]);
  const ads = {
    R1: {
      en: "EnPalo_ROS_336x280_R1",
      bn: "News_336x280_R1",
    },
    R2: {
      en: "EnPalo_ROS_300x250_R2",
      bn: "News_336x280_R2",
    },
  };

  const storyFields =
    "headline,subheadline,slug,url,hero-image-s3-key,hero-image-caption,hero-image-metadata,first-published-at,last-published-at,alternative,published-at,authors,author-name,author-id,sections,story-template,metadata,access,access-level-value,tags,cards";

  const loadPollingData = () => {
    setButtonSpinner(true);
    getPollingStories("poll", storyFields, offset, setButtonSpinner)
      .then((stories) => {
        setInActivePolls([...inActivePolls, ...stories]);
      })
      .finally(() => {
        setButtonSpinner(false);
      });
    setOffset(offset + 10);
  };

  useEffect(() => {
    setInActivePolls(stories.filter(({ active }) => !active));
  }, []);

  const activePolls = () => {
    const storyPollElements = [];
    stories.forEach(({ story, active }) => {
      if (
        (story["story-template"] === "poll" || story["story-template"] === "polls") &&
        story.cards &&
        story.cards.length &&
        active
      ) {
        story.cards.forEach((card) => {
          const cardElements = card["story-elements"];
          if (cardElements) {
            const pollElement = cardElements.find((element) => element.type === "polltype");

            if (pollElement) {
              storyPollElements.push(<Polltype key={pollElement["polltype-id"]} id={pollElement["polltype-id"]} />);
            }
          }
        });
      }
    });
    return storyPollElements;
  };

  return (
    <>
      <div styleName="poll-container">
        <div styleName="header-container">
          <div styleName="active-poll-container">{activePolls()}</div>
          <DfpContainer>
            <div styleName="ad-slot" className="adsBox">
              <DfpComponent
                type={ads.R1[lang]}
                slotId={getSlotId(ads.R1[lang], collectionSlug, "r1-ads-slot")}
                collectionSlug={collectionSlug}
                layoutName={layoutName}
              />
            </div>
          </DfpContainer>
        </div>
        <div styleName="poll-head-area">
          <div styleName="poll-head-title">{staticTexts().result}</div>
        </div>
        <div styleName="previous-poll-container">
          <div styleName="poll-story-area">
            {inActivePolls.length > 0 &&
              inActivePolls.map((poll, index) => <PollStory pollStory={poll?.story} key={index} index={index} />)}
          </div>
          <DfpContainer>
            <div styleName="side-ad" className="side-ad adsBox">
              <DfpComponent
                type={ads.R2[lang]}
                slotId={getSlotId(ads.R2[lang], collectionSlug, "Stories2AdWithLoadMore-sideAd")}
                layoutName={layoutName}
              />
            </div>
          </DfpContainer>
        </div>
        {inActivePolls.length >= 10 && inActivePolls.length % 10 === 0 && (
          <div styleName="load-more-view">
            <More
              type="load-more"
              text={staticTexts().more}
              onClick={loadPollingData}
              showButtonSpinner={showButtonSpinner}
            />
          </div>
        )}
      </div>
    </>
  );
}

PollResults.propTypes = {
  collection: object,
  collectionSlug: string,
  lang: string,
};
